module.exports = __webpack_public_path__ + "static/media/Tekion_logo.a1ac3716.jpeg";